<template>

  <div style="overflow: hidden;">
    <div class="card">
      <div class="card-body">
        <highcharts
          :options="chartOptions">
          </highcharts>
      </div>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'JobReport',
  components: {
    highcharts: Chart
  },
  props: {
    grid: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'bar'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Average number of days in the stage')
        },
        xAxis: {
          categories: ['']
        },
        yAxis: {
          min: 0,
          // tickInterval: 5,
          endOnTick: false,
          maxPadding: 0,
          title: {
            text: ''
          }
        },
        legend: {
          reversed: true
        },
        tooltip: {
          pointFormat: '<b>{series.name}</b>: {point.y}d'
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: this.grid.reverse().map((v) => {
          return {
            name: v.name,
            data: [v.avg_days]
          }
        })
      }
    }
  },
  created () {
  },
  methods: {
    getOriginName (origin) {
      return {
        'sourced': 'Sourced',
        'referred': this.$t('Referred'),
        'applied': this.$t('Applied'),
        'internal_applied': this.$t('Internal applied')
      }[origin] || 'N/D'
    },
    getSourceName (source) {
      return source || 'N/D'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReportPipelineSpeed.vue